import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../context/AuthContext";
import { post, del } from "aws-amplify/api";

export default function FollowButton({ authorUsername, initialIsFollowing = false, className = "" }) {
  const { user } = useContext(AuthContext);
  const [isFollowing, setIsFollowing] = useState(initialIsFollowing);
  const [isLoading, setIsLoading] = useState(false);
  
  // Check if the user is already following this author
  useEffect(() => {
    const checkFollowStatus = async () => {
      if (!user) return;
      
      try {
        const response = await post({
          apiName: 'userApi',
          path: '/follow/check',
          options: {
            body: {
              targetUsername: authorUsername
            }
          }
        });
        
        setIsFollowing(response.body.isFollowing);
      } catch (error) {
        console.error("Error checking follow status:", error);
      }
    };
    
    checkFollowStatus();
  }, [user, authorUsername]);
  
  const handleFollow = async () => {
    if (!user) {
      // Prompt user to sign in
      alert("Please sign in to follow this author");
      return;
    }
    
    setIsLoading(true);
    
    try {
      if (isFollowing) {
        // Unfollow
        await del({
          apiName: 'userApi',
          path: `/follow/${authorUsername}`
        });
        setIsFollowing(false);
      } else {
        // Follow
        await post({
          apiName: 'userApi',
          path: '/follow',
          options: {
            body: {
              targetUsername: authorUsername
            }
          }
        });
        setIsFollowing(true);
      }
    } catch (error) {
      console.error("Error updating follow status:", error);
    } finally {
      setIsLoading(false);
    }
  };
  
  // Don't show follow button for own profile
  if (user && user.username === authorUsername) {
    return null;
  }
  
  return (
    <button
      onClick={handleFollow}
      disabled={isLoading}
      className={`px-4 py-1 rounded-full ${
        isFollowing
          ? "bg-gray-200 text-gray-700 hover:bg-gray-300"
          : "bg-taupe text-white hover:bg-taupe-dark"
      } transition ${className}`}
    >
      {isLoading ? "..." : isFollowing ? "Following" : "Follow"}
    </button>
  );
}